(() => {
  const initialize = (root) => {
    if (root.dataset.supportReady) return;
    root.dataset.supportReady = 'true';
    const tools = root.querySelector('[data-support-tools]');
    const search = root.querySelector('[data-support-search]');
    const entries = [...root.querySelectorAll('[data-support-entry]')];
    const buttons = [...root.querySelectorAll('[data-support-filter]')];
    const groups = [...root.querySelectorAll('[data-support-group]')];
    const status = root.querySelector('[data-support-status]');
    const empty = root.querySelector('[data-support-empty]');
    if (!tools || !search || !status || !empty) return;
    let category = 'all';
    const normalize = (value) => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const records = entries.map((element) => ({ element, text: normalize(element.textContent) }));
    const update = () => {
      const words = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
      let visible = 0;
      records.forEach(({ element, text }) => {
        const matches = (category === 'all' || category === element.dataset.supportCategory) && words.every((word) => text.includes(word));
        element.hidden = !matches;
        if (matches) visible += 1;
      });
      groups.forEach((group) => { group.hidden = ![...group.querySelectorAll('[data-support-entry]')].some((entry) => !entry.hidden); });
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.supportFilter === category)));
      empty.hidden = visible > 0;
      status.textContent = visible === entries.length ? `${visible} in this selection` : `${visible} of ${entries.length} shown`;
    };
    buttons.forEach((button) => button.addEventListener('click', () => { category = button.dataset.supportFilter; update(); }));
    search.addEventListener('input', update);
    root.querySelector('[data-support-reset]')?.addEventListener('click', () => { category = 'all'; search.value = ''; update(); search.focus(); });
    tools.hidden = false;
    update();
  };
  const scan = (scope) => {
    if (scope.matches?.('[data-community-support]')) initialize(scope);
    scope.querySelectorAll('[data-community-support]').forEach(initialize);
  };
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
